import { Box, Link } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { PANCAKE_LP_USDT_STM, STAKE_FACTORY, lpDecimals, getWeb3,FACTORY_ABI, TOKEN_ABI } from "../web/util.js";
// import theme from "../../../assets/theme/index.js";
// import DefaultInput from "../../../components/Input/Default/index.js";
import ProvideContainer from "./provide.js";
import { toast,ToastContainer } from "react-toastify";
import Web3 from 'web3';
import dayjs from 'dayjs';

const ProvidedLiquidityContainer = ({ onAddLiquidity, onAlert }) => {

  let curWeb = getWeb3();
  if(!window.web3Con){
    let web3Con = new Web3(curWeb);
    window.web3Con = web3Con;
  }
  let LPContract = new window.web3Con.eth.Contract(TOKEN_ABI, PANCAKE_LP_USDT_STM);
  let FactoryContract = new window.web3Con.eth.Contract(FACTORY_ABI, STAKE_FACTORY);
  const [lpBalance, setLPBalance] = useState(0);
  const [genesis, setGenesis] = useState(0);
  const [leftSeconds, setLeftSeconds] = useState(0);
  const [publicAddress, setPublicAddress] = useState("");
  const [isOwner, setIsOwner] = useState(false)

  const initBalance = async () => {

    if (curWeb) {
      let accounts = await window.web3Con.eth.getAccounts();
      if(accounts.length){
        let curAddr = accounts[0];
        setPublicAddress(curAddr);
        let LP = await LPContract.methods.balanceOf(curAddr).call();
        setLPBalance(LP/ Math.pow(10, lpDecimals));
        let factoryOwner = await FactoryContract.methods.owner().call();
        if(factoryOwner == curAddr)
          setIsOwner(true);
        let stakingRewardsGenesis = await FactoryContract.methods.stakingRewardsGenesis().call();
        let startTime = dayjs.unix(stakingRewardsGenesis);
        setGenesis(startTime.format('YYYY-MM-DD HH:mm:ss'));
        let now = dayjs();
        let left = startTime.diff(now,'seconds');
        if(left<0) 
          setLeftSeconds(0);
        else
          setLeftSeconds(left);
        if(factoryOwner == curAddr)
          setIsOwner(true);
        else
          setIsOwner(false);
      }
    }
  };
  const notifyRewardAmounts = async () => {
    if(leftSeconds > 0){
      window.alert('time no reach!');
    }else{
      try {
        await FactoryContract.methods.notifyRewardAmounts().send({ from: publicAddress});
        toast.success('stake start.');
      } catch (error) {
        // console.log(error);
        toast.warn(error);
      }
    }
  };

  useEffect(() => {
    var interval = setInterval(initBalance, 1000)
    return () => clearInterval(interval)
  }, [curWeb]);

  return (
    <Box className="pool-wd-one">
      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
    />
    <ToastContainer />
      <Box className="pool-wrp pool-wrp1">
        <Box className="pool-dt">
          <h3>Liquidity</h3>
          <p>Add liquidity to receive BSC-USD-STM</p>
        </Box>
        <Box className="main-btn">
          {/* <Link href="#" className="pool-wrp1-btn" onClick={e => { onAddLiquidity() }}>
            Add Liquidity
          </Link> */}
          <Link href="https://pancakeswap.finance/add/0xaAaCB15E4c5E9A7187a94BeCF280889343fA9EC4/0x55d398326f99059fF775485246999027B3197955"
                target="blank"
                className="pool-wrp2-btn">
            Go Pancake to Add
          </Link>
        </Box>

        <ProvideContainer lpBalance={lpBalance}/>
        <Box className="Textfield-wrp  table-wrp">
          <Box className="LPT-wrp">
            <h6>Your Liquidity:</h6>
            <h3>
              {lpBalance} <span style={{opacity:100}}> BSC-USD-STM</span>
            </h3>
            <Box className="main-btn">
              <Link
                href="https://pancakeswap.finance/liquidity"
                target="blank"
                className="pool-wrp2-btn"
              >
                Go Pancake to remove
              </Link>
            </Box>
          </Box>
          <Box className="clear"></Box>
        </Box>
        {
          isOwner?(
            <Box className="tbs-fot">
              <h3>section show only owner</h3><br/>
              <h3>stakingRewardsTime:</h3>
              <h6> {genesis} </h6><br/>
              <h6> {leftSeconds} <span> seconds left</span></h6>
            <Box className="main-btn">
              <Link className="pool-wrp2-btn" onClick={notifyRewardAmounts}>
                  Start Rewards
              </Link>
              </Box>
          </Box>
          ):null
        }
      </Box>
    </Box>
  );
};

export default ProvidedLiquidityContainer;